/** Loading skeleton and friendly error with "Tentar de novo". */
export function Loading() {
  return (
    <div
      className="pv-container pv-stack"
      aria-busy="true"
      aria-label="Carregando"
    >
      <div className="pv-skeleton" style={{ height: 120 }} />
      <div className="pv-skeleton" style={{ height: 200 }} />
      <div className="pv-skeleton" style={{ height: 200 }} />
    </div>
  );
}

interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({
  message = 'Não foi possível carregar agora.',
  onRetry,
}: ErrorStateProps) {
  return (
    <div className="pv-container">
      <div className="pv-card pv-center pv-stack" role="alert">
        <p>{message}</p>
        {onRetry && (
          <button
            type="button"
            className="pv-btn pv-btn--primary"
            onClick={onRetry}
          >
            Tentar de novo
          </button>
        )}
      </div>
    </div>
  );
}
